// User-facing chat copy in one place. No emoji.
export const greeting = (firstName) => `Hey ${firstName || "there"}. How are you arriving today?`;

// True for the welcome line (any name). The first-open screen already shows it, so the conversation does not repeat it.
export const isGreeting = (text) => /^Hey .+\. How are you arriving today\?$/.test(text || "");

export const PLACEHOLDER = "Tell Rigby how you're feeling";
